import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { User } from '../../types/User';
import { Layout } from '../Layout/Layout';
import { UserNameOptions } from './types';
import { UserAvatar } from './UserAvatar';
import { UserName } from './UserName';

interface Props {
  user?: User;
  options?: UserNameOptions;
  placeholder?: string;
}

export const UserAvatarName = memo(
  ({ options = {}, user, placeholder: initialPlaceholder }: Props) => {
    const intl = useIntl();

    const { date } = options;

    const placeholder = initialPlaceholder
      ? initialPlaceholder
      : intl.formatMessage({
          id: 'UserAvatarName.placeholder',
          defaultMessage: 'Unknown User',
          description:
            'Placeholder text for user info when no user data is available',
        });

    return (
      <Layout align="center" spacing={2} maxW="100%">
        <UserAvatar
          options={{ date, size: 'm' }}
          user={user}
          placeholder={placeholder}
        />
        <UserName
          mode="full"
          user={user}
          options={options}
          placeholder={placeholder}
        />
      </Layout>
    );
  },
);
